import React from 'react'
import { AuthContext } from '../../../contexts/AuthContext'
import DeskEmpresas from './DeskEmpresas'
import MobileEmpresas from './MobileEmpresas'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { useLocation } from 'react-router-dom'

import './stylesEmp.css'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'

export default function Empresas() {
  const location = useLocation()
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { userUCtx, actionsUCtx } = React.useContext(UsuarioContext)
  const { sttPg, actionsCtxEmps } = React.useContext(EmpresasContext)
  const { actionsAgend } = React.useContext(AgendamentoContext)

  React.useEffect(() => {
    document.title = 'Empresas | Agendei Quadras'
    actionsAgend.ResetReagendamento()
    actionsCtxEmps.ValidarDataDispositivo()
    let cidadelabel = location.pathname.split('/').pop()
    actionsCtxEmps.handleSttPg('modePg', 'empresas')
    // console.log('userContext', userUCtx.usuario)
    if (sttAuthCtx.isLogged) actionsUCtx.BuscarUltimoPedido()
    if (
      sttAuthCtx.isLogged &&
      (!userUCtx.usuario?.atleta.telefone || !userUCtx.usuario?.atleta.nascimento)
    ) {
      actionsCtxEmps.handleModaisCE('modalL', true)
    } else if (cidadelabel === ':localizacao') {
      actionsCtxEmps.handleModaisCE('modalL', true)
    } else if (cidadelabel && cidadelabel !== ':localizacao') {
      cidadelabel = cidadelabel.split('-').slice(1)
      cidadelabel = cidadelabel.join(' ')
      actionsCtxEmps.BuscarEmpresasCidade(cidadelabel)
    } else if (sttAuthCtx.isLogged && userUCtx.usuario.cidade !== null) {
      actionsCtxEmps.BuscarEmpresasCidade(userUCtx.cidade)
    } else {
      actionsCtxEmps.handleModaisCE('modalL', true)
    }
  }, [userUCtx.usuario, sttPg.updateEmpresa, sttAuthCtx.isLogged])

  return <>{!sttAuthCtx.isMobile ? <DeskEmpresas /> : <MobileEmpresas />}</>
}
